import http from "../../utils/http"

/**
 * 获取推广订单列表
 */
export function getFenxiaoOrderList(params) {
    return http({
        url: "/fenxiao/api/order/page",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取推广订单详情
 */
export function getFenxiaoOrderDetail(params) {
    return http({
        url: "/fenxiao/api/order/info",
        data: params,
        forceLogin: true
    })
}

/**
 * 获取推广订单统计
 */
export function getFenxiaoOrderStats(params) {
    return http({
        url: "/fenxiao/api/order/stats",
        data: params,
        forceLogin: true
    })
}